<template>
  <v-dialog v-model="modal" scrollable>
    <v-card>
      <v-card-title>
        Sélection de contact
      </v-card-title>
      <v-card-subtitle>{{ subtitle }}</v-card-subtitle>
      <v-card-text>
        <v-row>
          <v-col cols="12" sm="4">
            <search-by
              :datasource="datasource"
              attr="nom"
              i18n="recherche.rechercheSimple.personnePhysique.search.nom"
            />
          </v-col>
          <v-col cols="12" sm="4">
            <search-by
              :datasource="datasource"
              attr="prenom"
              i18n="recherche.rechercheSimple.personnePhysique.search.prenoms"
            />
          </v-col>
          <v-col cols="12" sm="4">
            <search-by
              :datasource="datasource"
              attr="raisonSociale"
              i18n="recherche.rechercheSimple.personnePhysique.search.raisonSociale"
            />
          </v-col>
        </v-row>
        <datasource-table style="height:480px;" :datasource="datasource">
          <template #item.raisonSociale="{item}">
            {{ item.raisonSociale }}
          </template>

          <template #item.nom="{item}">
            <a @click="select(item)">
              {{ item.nom }}
            </a>
          </template>
          <template #item.prenoms="{item}">
            <a @click="select(item)">
              {{ item.prenoms }}
            </a>
          </template>

          <template #item.telephone="{item}">
            <span class="text-no-wrap">{{
              getInternational(item.telephone)
            }}</span>

            <v-tooltip v-if="item.telephoneConfidentiel" bottom>
              <template #activator="{ on }">
                <v-icon v-on="on">mdi-eye-off</v-icon>
              </template>
              <span>Confidentiel</span>
            </v-tooltip>
          </template>

          <template #item.mail="{item}">
            {{ item.mail }}
            <v-tooltip v-if="item.mailConfidentiel" bottom>
              <template #activator="{ on }">
                <v-icon v-on="on">mdi-eye-off</v-icon>
              </template>
              <span>Confidentiel</span>
            </v-tooltip>
          </template>

          <template #item.nomUsuel="{item}">
            <a @click="select(item)">
              {{ item.nomUsuel }}
            </a>
          </template>
          <template #item.raisonSociale="{item}">
            <a @click="select(item)">
              {{ item.raisonSociale }}
            </a>
          </template>
        </datasource-table>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn @click="closeModal" text>
          {{ $t('button.cancel') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Datasource from '@/utils/datasource';
import { getInternational } from '@/components/telephone/telephoneUtil.js';

export default {
  props: {
    subtitle: {
      type: String,
    },
  },
  data() {
    const datasource = new Datasource('recherche/simple/contact', {
      page: 1,
      rowsPerPage: 20,
      sortBy: ['nom'],
      descending: [false],
      labelNamespace: 'recherche.rechercheSimple.personnePhysique.list',
      fields: [
        {
          value: 'nom',
          sortable: true,
        },
        {
          value: 'prenoms',
          sortable: true,
        },
        {
          value: 'raisonSociale',
          sortable: true,
          text: this.$t(
            'recherche.rechercheSimple.personnePhysique.list.headers.personneMorale',
          ),
        },

        {
          value: 'fonction',
          sortable: true,
          text: this.$t(
            'recherche.rechercheSimple.personnePhysique.list.headers.fonction',
          ),
        },
        {
          value: 'telephone',
          sortable: false,
          text: this.$t(
            'recherche.rechercheSimple.personnePhysique.list.headers.telephone',
          ),
        },
        {
          value: 'mail',
          sortable: false,
          text: this.$t(
            'recherche.rechercheSimple.personnePhysique.list.headers.mail',
          ),
        },
      ],
    });
    return {
      datasource,
      modal: false,
    };
  },
  methods: {
    getInternational,
    show() {
      this.modal = true;
    },
    select(item) {
      this.modal = false;
      this.$emit('input', { ...item });
    },
    closeModal() {
      this.modal = false;
    },
  },
};
</script>
